import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import DOMPurify from 'dompurify';
import SocialSharing from './socialmediashare';

function Video(props){
    const [pipmode,setPipmode] = useState(false)
    const doplay = () =>{

      
    }

    return(

        <>
        


        <div className="row feeditem" style={{width:"100%", margin:"10px auto", position:"relative"}}>
            {/* <Link onClick={doplay()} style={{display:"block", width:"100%"}}> */}

            <div className="titleLabel" style={{padding: "20px 0px", color:"#333333", width:"100%"}} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.title)}}></div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width:"100%"}} className="storyImage">
                <div style={{background: "#000000a9", position: "absolute", color: "#ffffff", border: "1px solid #ffffff",
    borderRadius: "200px", padding: "6px 18px", fontSize: "28px"}}><i className='fa fa-play'></i></div>
                {/*<img src={props.thumbnail} style={{width:"100%"}} />*/}
            </div>
       <div style={{width: "100%", position:"relative", display:"block", borderRadius:"20px", overflow:"hidden"}}>
           <ReactPlayer url={props.video} controls={true} light={"https://i4.ytimg.com/vi/"+props.vid+"/hqdefault.jpg"} width="100%" pip={pipmode} stopOnUnmount={true} playing />
           </div>
       
       {/* </Link> */}
       <div style={{color:"rgb(151 146 146)", fontSize:"12px", margin:"10px 0px", textAlign:"left"}}>Source: Joy News channel</div>
        <div className="interactiveicons">


        {/* <ShareButtons title={props.title} url={props.video} twitterHandle={"_MsLinda"} tags={props.title}/> */}
        <SocialSharing title={props.title} url={props.video}  tags={props.title} />
        
        </div> 
        
        </div>

        </>
    )
}

export default Video;